
//-----------------------|| securities MENU ITEMS ||-----------------------//
export const Admin = {
    id: 'admin',
    title: 'Admin',
    type: 'collapse',
    icon: 'IconUsers',
    children: [
        {
            id: 'auth.view_user',
            title: 'User Mgmt',
            type: 'item',
            url: '/user_profiles',
            icon: 'IconUsers',
            breadcrumbs: false
        },
        {
            id: 'auditlog.view_logentry',
            title: 'Audit Logs',
            type: 'item',
            url: '/audit_logs',
            icon: 'IconFolderSearch',
            breadcrumbs: false
        },
        {
            id: 'masters.view_scrapedjobtracker',
            title: 'Fetch Portal Status',
            type: 'item',
            url: '/scraping_progress_table',
            icon: 'IconDeviceDesktopDown',
            breadcrumbs: false
        },
        {
            id: 'masters.view_interviewbasicquestion',
            title: 'Interview Basic Questions',
            type: 'item',
            url: '/interview_basic_questions',
            icon: 'IconQuestionMark',
            breadcrumbs: false
        },
        {
            id: 'masters.view_implementerportalconfig',
            title: 'Settings',
            type: 'item',
            url: '/portal_config',
            icon: 'IconSettings',
            breadcrumbs: false
        }
    ]
};
